module.exports = __webpack_public_path__ + "static/img/png.c0a26a17.png";